import styles from "./cta-button.module.css";
import { filterClasses } from "PosterEditor/utils/filter-classes";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";

type Variant = "PRIMARY" | "SECONDARY" | "LINK";

interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  title?: string;
  iconName?: UIIconName;
  children?: React.ReactNode;
  disabled?: boolean;
}

export const CTAButton = ({
  variant = "PRIMARY",
  title,
  children,
  iconName,
  className,
  disabled,
  ...rest
}: CTAButtonProps) => {
  if (variant === "SECONDARY") {
    return (
      <SecondaryCTAButton
        title={title}
        iconName={iconName}
        className={filterClasses(className, disabled ? styles.disabled : null)}
        {...rest}
      >
        {children}
      </SecondaryCTAButton>
    );
  }
  if (variant === "LINK") {
    return (
      <LinkCTAButton
        title={title}
        iconName={iconName}
        className={filterClasses(className, disabled ? styles.disabled : null)}
        {...rest}
      >
        {children}
      </LinkCTAButton>
    );
  }

  return (
    <button
      className={filterClasses(
        styles.button,
        styles.ctaPrimary,
        className,
        disabled ? styles.disabled : null,
        iconName ? styles.left : styles.centered
      )}
      {...rest}
    >
      {iconName && <UIIcon iconName={iconName} variant="CONTRAST" size={34} />}
      {title}
      {children}
    </button>
  );
};

interface SecondaryCTAButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title?: string;
  iconName?: UIIconName;
  children?: React.ReactNode;
}

export const SecondaryCTAButton = ({
  title,
  iconName,
  children,
  className,
  ...rest
}: SecondaryCTAButtonProps) => {
  return (
    <button
      className={filterClasses(
        styles.button,
        styles.ctaSecondary,
        className,
        iconName ? styles.left : styles.centered
      )}
      {...rest}
    >
      {iconName && <UIIcon iconName={iconName} variant="REGULAR" size={34} />}
      {title}
      {children}
    </button>
  );
};

interface LinkCTAButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title?: string;
  iconName?: UIIconName;
  children?: React.ReactNode;
}

export const LinkCTAButton = ({
  title,
  iconName,
  children,
  className,
  ...rest
}: LinkCTAButtonProps) => {
  return (
    <button
      className={filterClasses(
        styles.button,
        styles.ctaLink,
        className,
        iconName ? styles.left : styles.centered
      )}
      {...rest}
    >
      {iconName && <UIIcon iconName={iconName} variant="REGULAR" size={34} />}
      {title}
      {children}
    </button>
  );
};
